/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubcontractorCreationRequest
 */
export interface SubcontractorCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCreationRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCreationRequest
     */
    name: string;
}

/**
 * Check if a given object implements the SubcontractorCreationRequest interface.
 */
export function instanceOfSubcontractorCreationRequest(value: object): value is SubcontractorCreationRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SubcontractorCreationRequestFromJSON(json: any): SubcontractorCreationRequest {
    return SubcontractorCreationRequestFromJSONTyped(json, false);
}

export function SubcontractorCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubcontractorCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
    };
}

export function SubcontractorCreationRequestToJSON(value?: SubcontractorCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'name': value['name'],
    };
}

